export default __webpack_public_path__ + "static/media/button_goback_ko.52323c40.svg";